module.exports = __webpack_public_path__ + "static/media/help-active.fa448819.png";